import { Moment } from "moment";
import { SchoolContactType } from "./school-contact-type";
import { SystemUser } from "./system-user";

export class SchoolContact {

    constructor(
     public schoolContactType: SchoolContactType,
     public name: string,
     public email: string,
     public phoneNumber: string,
     public created?: Moment | null,
     public createdBy?: SystemUser | null,
     public lastModified?: Moment | null,
     public lastModifiedBy?: SystemUser | null,
     public id?: number
    ){}
}
